/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProfileSuggestion } from './';
import {
    ProfileSuggestionFromJSON,
    ProfileSuggestionFromJSONTyped,
    ProfileSuggestionToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProfileSuggestionsResource
 */
export interface ProfileSuggestionsResource {
    /**
     * Ordered list of applicable suggestions for the current freelancer.
     * Empty when the task list is not fully completed — the "Suggested for you"
     * section must not be displayed in that case.
     * 
     * @type {Array<ProfileSuggestion>}
     * @memberof ProfileSuggestionsResource
     */
    suggestions: Array<ProfileSuggestion>;
}

/**
 * Check if a given object implements the ProfileSuggestionsResource interface.
 */
export function instanceOfProfileSuggestionsResource(value: object): value is ProfileSuggestionsResource {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    return true;
}

export function ProfileSuggestionsResourceFromJSON(json: any): ProfileSuggestionsResource {
    return ProfileSuggestionsResourceFromJSONTyped(json, false);
}

export function ProfileSuggestionsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileSuggestionsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestions': ((json['suggestions'] as Array<any>).map(ProfileSuggestionFromJSON)),
    };
}

export function ProfileSuggestionsResourceToJSON(value?: ProfileSuggestionsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestions': ((value['suggestions'] as Array<any>).map((v) => ProfileSuggestionToJSON(v))),
    };
}

